import {Dispatch, ThunkAction} from 'app/types/actions';
import { SegmentBoardEvent, segmentTrackAction } from 'app/middlewares/segment';

export const onEsc = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
    ) => {
        dispatch(segmentTrackAction(SegmentBoardEvent.ESCAPE_BOARD_DESCRIPTION_CHANGING));
    };
    return action;
};
